import styled from 'styled-components';

export const Step1 = styled.div`
    min-height: 100%;
    position: relative;
    overflow-y: hidden;

    .form-container {
        display: flex;
        flex-direction: column;
    }

    .form-row {
        margin-bottom: 1rem;
    }

    label {
        display: flex;
        flex-direction: row;
        font-weight: 500;
        width: 100%;
        align-items: center;
        font-size: 12px;
    }

    input {
        height: 20px;
        align-items: center;
        border-radius: 8px;
        margin-top: 4px;
        margin-right: 10px;
        border: 1px solid #ccc;
        padding: 1rem;
    }

    input::placeholder {
        font-size: 10px;
        font-style: italic;
        padding-top: 7px;
        margin-left: 5px;
    }
`;

export const Title = styled.h1`
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 1.2;
    display: flex;
    color: #0094f9;
`;

export const Phone = styled.div`
    display: flex;
    margin-top: 0px;
    .intl-tel-input {
        width: 100%;
    }
`;

export const Subtitle = styled.h1`
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.2;
    margin-top: 25px;
    margin-bottom: 25px;
    display: flex;
    gap: 1rem;
    align-items: baseline;

    p {
        color: #0094f9;
        font-weight: 600;
        font-size: 1.6rem;
    }

    @media (max-width: 768px) {
        font-size: 1.6rem;
    }
`;

export const Questions = styled.h1`
    font-size: 1.4rem;
    font-weight: 700;
    margin-top: 25px;
    margin-bottom: 15px;
    display: flex;
    gap: 1rem;
    align-items: baseline;

    @media (max-width: 768px) {
        font-size: 1.2rem;
    }
`;

export const Title1 = styled.h1`
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 1.2;
    margin: 0;
    display: flex;
    justify-content: space-between;
    color: black;
`;
